import { type FileType, FileTypeExtensionMap, FileTypeMimeTypeMap } from '../const/fileTypes';

export const getExtensionsByMimeTypes = (mimeTypes: string[]) => {
	let extensions: string[] = [];

	mimeTypes.forEach((type) => {
		const fileType = (Object.keys(FileTypeMimeTypeMap) as unknown as FileType[]).find((key) =>
			FileTypeMimeTypeMap[key].includes(type)
		);

		if (!fileType) {
			return;
		}

		extensions = [...extensions, ...FileTypeExtensionMap[fileType]];
	});

	return [...new Set(extensions)];
};
